var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getCurrentUser } from './authUtils';
import { convertUserGroupStringToEnum, isAnyGroupInGroupList, isEveryGroupInGroupList, isGroupInGroupList, isUserAdmin } from './UserGroups';
import { UserPropertyKeys } from './UserProperties';
/**
 * TODO: expire the cache when the refresh token is used
 */
var AuthCache = /** @class */ (function () {
    function AuthCache() {
        AuthCache.refresh();
    }
    AuthCache.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, userGroups;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('Refreshing the auth cache from the current user');
                        return [4 /*yield*/, getCurrentUser()];
                    case 1:
                        user = _a.sent();
                        console.log('Found User when populating the cache:', user);
                        AuthCache.cachedUser = user;
                        userGroups = AuthCache.getUncachedCurrentUserGroups();
                        console.log('Found User groups when populating the cache:', userGroups);
                        AuthCache.userGroupCache = userGroups;
                        return [2 /*return*/];
                }
            });
        });
    };
    //TODO: remove and instead ensure that the cache is refreshed on app load? are there times when the info would change and we would need to make sure it was refreshed here?
    // static async getCachedUserAttributeWithRefresh(attributeName: CognitoPropertyKeys): Promise<string | undefined> {
    //   await AuthCache.refresh();
    //   return AuthCache.getCachedUserAttribute(attributeName);
    // }
    /**
     * A synchronous version of getCachedUserAttributeWithRefresh
     * The trade-off is that this version assumes the cache is prefilled.
     * It does not fill it if the cache does not exist yet
     */
    AuthCache.getCachedUserAttribute = function (attributeName) {
        var _a;
        return (_a = AuthCache.cachedUser) === null || _a === void 0 ? void 0 : _a[attributeName];
    };
    AuthCache.getCurrentUserId = function () {
        var userIdAttribute = AuthCache.getCachedUserAttribute(UserPropertyKeys.userID);
        if (Array.isArray(userIdAttribute)) {
            if (userIdAttribute.length === 0)
                return undefined;
            return userIdAttribute[0];
        }
        return userIdAttribute;
    };
    AuthCache.getCurrentUserGroups = function () {
        return AuthCache.userGroupCache;
    };
    AuthCache.getUncachedCurrentUserGroups = function () {
        console.log('Getting uncached user groups');
        var groupsAsAttribute = AuthCache.getCachedUserAttribute(UserPropertyKeys.groups);
        console.log('Groups as attribute when attempting to cache user groups:', groupsAsAttribute);
        if (!groupsAsAttribute) {
            console.log('No groups attribute found when attempting to cache user groups');
            return undefined;
        }
        if (typeof groupsAsAttribute === 'string') {
            console.log("User group attribute was a string.  Converting to enum");
            var enumValue = convertUserGroupStringToEnum([groupsAsAttribute]);
            if (!enumValue)
                return undefined;
            return enumValue;
        }
        return convertUserGroupStringToEnum(groupsAsAttribute);
    };
    AuthCache.isCurrentUserInGroup = function (group) {
        console.log('Checking if user is in group', group);
        if (!AuthCache.userGroupCache) {
            console.log('No user group cache when verifying specific group membership');
            return false;
        }
        return isGroupInGroupList(group, AuthCache.userGroupCache);
    };
    AuthCache.isCurrentUserInAnyGroup = function (groups, includeTechSupport) {
        if (includeTechSupport === void 0) { includeTechSupport = true; }
        console.log('Checking if user is in any group', groups);
        if (!AuthCache.userGroupCache) {
            console.log('No user group cache when verifying any group membership');
            return false;
        }
        return isAnyGroupInGroupList(AuthCache.userGroupCache, groups, includeTechSupport);
    };
    AuthCache.isCurrentUserInEveryGroup = function (groups, includeTechSupport) {
        if (includeTechSupport === void 0) { includeTechSupport = true; }
        console.log('Checking if user is in every group', groups);
        if (!AuthCache.userGroupCache) {
            console.log('No user group cache when verifying every group membership');
            return false;
        }
        return isEveryGroupInGroupList(groups, AuthCache.userGroupCache, includeTechSupport);
    };
    AuthCache.isCurrentUserAdmin = function () {
        if (!AuthCache.userGroupCache) {
            console.log('No user group cache when verifying admin membership');
            return false;
        }
        return isUserAdmin(AuthCache.userGroupCache);
    };
    AuthCache.getCurrentUserFullName = function () {
        var firstName = AuthCache.getCachedUserAttribute(UserPropertyKeys.firstName);
        var lastName = AuthCache.getCachedUserAttribute(UserPropertyKeys.lastName);
        if (!firstName || !lastName)
            return undefined;
        return "".concat(firstName, " ").concat(lastName);
    };
    AuthCache.invalidateCache = function () {
        AuthCache.cachedUser = undefined;
    };
    return AuthCache;
}());
export default AuthCache;
